import { getBillingInvoiceRemarkFun, getCurrencyAmount } from '@/api/clearing/billingNative'
import { getUserInfo } from '@/utils/auth'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import lang from '@/lang'
import $store from '@/store'
import * as NumberUtils from '@/utils/NumberUtils'
import DateUtils from '@/utils/dateUtils'
import { Message } from '@/utils/Message'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import StrUtils from '@/utils/StrUtils'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { getChargeList } from '@/api/seaExport/seaExportJob'
import { User } from '@/class/model/sys/User'
import { getLoading } from '@/utils/utilBaseElement'
import { cache } from '@/utils/cacheManager'
import {
  BILLING_NOT_PRINTED,
  BILLING_NOT_REVIEW,
  BILLING_REVIEWED,
  BILLING_STATE_NOT_REVIEW,
  BILLING_STATE_REVIEWED
} from '@/class/cargo/model/parameters/BillingConstants'

/**
 * 创建新的账单集合
 * @param sourceBillings
 * @returns []
 */
export function entryConvertToObject(sourceBillings) {
  const billings = []
  if (!sourceBillings || sourceBillings.length === 0) {
    return billings
  }
  for (let i = 0; i < sourceBillings.length; i++) {
    const billing = sourceBillings[i]
    // 组装对账单详情界面-账单列表实体
    const newBilling = {
      'uuid': billing.uuid,
      'billingUuid': billing.uuid,
      'version': billing.version,
      'billingVersion': billing.version,
      'billingGroupUuid': billing.billingGroupUuid,
      'billingNo': billing.billingNo,
      'title': billing.title,
      'accountId': billing.accountId,
      'settlementAgentId': billing.settlementAgentId,
      'ar': billing.ar,
      'currency': billing.currency,
      'amount': billing.amount,
      'rate': billing.rate,
      'billingType': billing.billingType,
      'billingEtd': billing.billingEtd,
      'jobVesselVoyageFlight': billing.voyageFlight,
      'branchId': billing.branchId,
      'inputDate': billing.inputDate
    }
    billings.push(newBilling)
  }
  return billings
}

/**
 * 创建新的对账单实体
 * @param billingGroup
 * @param newBillings
 * @returns billingGroup
 */
export async function createBillingGroup(billingGroup, newBillings) {
  // 组装对账单实体
  const currentUserInfo = getUserInfo()
  // 判断是否含有代理分成账单，如果有，则对账单的账单类型为国外账单
  let hasAgentBilling = false
  for (const billing of newBillings) {
    if (billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
      if (!hasAgentBilling) {
        hasAgentBilling = true
        break
      }
    }
  }
  const newBilling = newBillings[0]
  billingGroup.accountId = newBilling.settlementAgentId
  billingGroup.branchId = $store.getters.currentOfficeId
  billingGroup.inputDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
  billingGroup.inputBy = currentUserInfo.userId
  billingGroup.inputByDep = $store.getters.currentDeptId
  billingGroup.billingType = hasAgentBilling ? BillingConstants.BILLING_TYPE_OVERSEA.code : newBilling.billingType
  billingGroup.currency = checkBillingGroupCurrency(newBillings)
  billingGroup.billingKeys = []
  billingGroup.invoiceType = billingGroup.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code ? InvoiceConstant.BILLING_INVOICE_TYPE_VAT.code : ''
  billingGroup.invoiceMakeType = billingGroup.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code ? InvoiceConstant.BILLING_INVOICE_CATEGORY_ELECTRONIC_INVOICE.code : ''
  await checkBillingGroupAmount(billingGroup, newBillings, true)
  return billingGroup
}
/**
 * 确认对账单币种
 * @param billings
 * @returns currency
 */
export function checkBillingGroupCurrency(billings) {
  let currency = null
  for (let i = 0; i < billings.length; i++) {
    const sourceCurrency = billings[i].currency
    if (currency === null) {
      currency = sourceCurrency
    } else if (currency !== sourceCurrency) {
      const localCurrency = RateUtil.localCurrencyByOfficeId(billings[i].branchId)
      currency = localCurrency
      break
    }
  }
  return currency
}

/**
 * 计算对账单金额
 * @param billingGroup
 * @param billings
 * @param checkAr
 */
export async function checkBillingGroupAmount(billingGroup, billings, checkAr = false) {
  // 根据账单重新重新计算对账单的币种
  billingGroup.currency = checkBillingGroupCurrency(billings)
  // 汇总账单金额
  let totalAr = 0.00
  let totalAp = 0.00
  for (let i = 0; i < billings.length; i++) {
    const billing = billings[i]
    const rate = await RateUtil.getForeignExchangeRateSafely(billingGroup.currency, billing.currency, billingGroup.inputDate, billing.branchId, 0, true)
    let amount = billing.amount * rate
    amount = RateUtil.getAmountByCurrency(amount, billingGroup.currency)
    if (billing.ar) {
      totalAr += amount
    } else {
      totalAp += amount
    }
  }
  // 新增加入账单时，可以刷新账单收付状态
  if (checkAr) {
    if (totalAr === totalAp) {
      if (billingGroup.makeBillingGroupPaymentReceiveMethod === 1) {
        billingGroup.ar = true
      } else if (billingGroup.makeBillingGroupPaymentReceiveMethod === 0) {
        billingGroup.ar = false
      } else { // 其他情况默认取站动感的第一条的收付类型
        billingGroup.ar = billings[0].ar
      }
    } else {
      billingGroup.ar = totalAr >= totalAp
    }
  }
  // billingGroup.amount = NumberUtils.roundHalfUp((totalAr - totalAp) * (billingGroup.ar ? 1 : -1), 2)
  billingGroup.amount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency((totalAr - totalAp) * (billingGroup.ar ? 1 : -1), billingGroup.currency), 2)
  return billingGroup
}

/**
 * 动态计算分币种合计
 * @param billingGroup
 * @returns billingGroup
 */
export async function refreshCurrencyAmount(billingGroup) {
  let currencyAmount = ''
  const conditions = []
  const condition = new AdvancedSearchOption(null, 'billing.UUID', billingGroup.billingKeys, OperatorConstants.OPERATOR_IN.code)
  conditions.push(condition.formatObj2Json())
  const requestBody = { conditions, paging: false, ar: billingGroup.ar }
  currencyAmount = await getCurrencyAmount(requestBody).then(res => {
    return res.data
  })
  billingGroup.currencyAmount = currencyAmount
  return billingGroup
}

/**
 * 是否可编辑
 */
export function editable(billing) {
  if (billing.billingGroupUuid) {
    Message.warning(lang.t('act.billing.hasBillingGroup', [billing.billingNo]))
    return false
  }
  if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) {
    if ((billing.state > 0 && billing.state !== BillingConstants.BILLING_INVOICED.code) || billing.confirmed) {
      Message.warning(lang.t('act.billing.hasConfirmed', [billing.billingNo]))
      return false
    }
  } else {
    if (billing.state > 0) {
      Message.warning(lang.t('act.billing.hasConfirmed', [billing.billingNo]))
      return false
    }
  }
  if (billing.review === 1) {
    Message.warning(lang.t('act.billing.hasReviewed', [billing.billingNo]))
    return false
  }
  return true
}

/**
 * 校验费用的开票抬头是否一致，不一致时弹窗确认
 * @param item billing
 * @param charges 费用列表
 * @param view
 * @param useFirstChargeInvoiceTitle 是否使用第一条费用的开票抬头
 * @returns {Promise<boolean>}
 */
export async function checkBillingIsSameInvoiceTitle(billingGroup, billings, view) {
  if (!billings || billings.length === 0 || billingGroup['billingType'] !== BillingConstants.BILLING_TYPE_INTERNAL.code) {
    return false
  }
  const sameTitle = isSameInvoiceTitle(billings)
  let checkTitle = false
  if (sameTitle === 1) {
    billingGroup.title = billings[0].title
    return checkTitle
  }
  await view.$confirm(lang.t('Message.TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue'), lang.t('Message.Prompt'), {
    confirmButtonText: lang.t('common.btn.ok'),
    cancelButtonText: lang.t('common.btn.cancel'),
    distinguishCancelAndClose: true,
    type: 'warning'
  }).then(() => {
    billingGroup.title = billings[0].title
  }).catch(() => {
    checkTitle = true
  })
  return checkTitle
}
export function isSameInvoiceTitle(billings) {
  // 只有一票费用时，直接取该票费用的开票抬头
  if (billings.length === 1) {
    return 1
  }
  let title = ''
  for (const billing of billings) {
    // 忽略开票抬头为空的数据
    if (StrUtils.isEmpty(billing.title)) {
      continue
    }
    if (StrUtils.isEmpty(title)) {
      title = billing.title
      continue
    }
    // 出现不一致的开票抬头时，直接返回不一致的结果
    if (title !== billing.title) {
      return 0
    }
  }
  return 1
}

/**
 * 获取账单页签的费用
 * @param view
 * @param job
 * @param onlySlaveCharge 是否仅返回小票费
 * @param oversea
 * @param {Object} otherParams
 * {
 *  enableCommission,
 *  showSpecialCharge,
 *  currentBillingBranchId,
 *  viewSource, // 可选
 *  departmentTeamUser
 * }
 * @param filterFunction 可选
 */
export async function getBillTabCharges(view, job, onlySlaveCharge, oversea, otherParams, filterFunction = null) {
  const { viewSource } = otherParams
  let departmentTeamUser = otherParams.departmentTeamUser
  const billCharges = []
  // 所有费用
  const branchChargeRole = view.$checkPermission(['role_Charge_branchCharge'])
  // 本人及同组费用
  const departmentChargeRole = view.$checkPermission(['role_Charge_departmentCharge'])
  // 本人费用
  const userChargeRole = view.$checkPermission(['role_Charge_userCharge'])
  if (!onlySlaveCharge) {
    // 是否有应付受控费用权限
    const isControlled = view.$checkPermission(['button_Charge_controlled'])
    // 是否有应收受控费用权限
    const isCostControlled = view.$checkPermission(['button_Charge_costControlled'])
    // 获取当前job上的费用list
    const jobCharges = await getChargeList(job.uuid).then(res => {
      if (typeof filterFunction === 'function') {
        return filterFunction(res.data)
      }
      return res.data
    })
    const curCharges = []
    for (const item of jobCharges) {
      if (item.autoGenerated) {
        continue
      }
      const controlled = item.controlled // 是否受控
      const receivable = item.receivable // 应收应付
      if (controlled) {
        if (receivable && !isCostControlled) {
          continue
        }
        if (!receivable && !isControlled) {
          continue
        }
      }
      curCharges.push(item)
    }
    const matchCharges = matchBillTabCharges(view, curCharges, oversea, otherParams)
    billCharges.push(...matchCharges)
  }
  if (job.masterFlag) {
    for (const job of job.lclSlaves) {
      const lclJobCharges = await getChargeList(job.uuid).then(res => {
        if (typeof filterFunction === 'function') {
          return filterFunction(res.data)
        }
        return res.data
      })

      const curCharges = []
      for (const item of lclJobCharges) {
        if (item.autoGenerated) {
          continue
        }
        curCharges.push(item)
      }
      const matchCharges = matchBillTabCharges(view, curCharges, oversea, otherParams)
      billCharges.push(...matchCharges)
    }
  }
  if (viewSource && viewSource === 'salesDetail') {
    return matchBillChargesByCreateByRole(view, billCharges, otherParams)
  } else {
    if (branchChargeRole || checkChargeCreatedBy(job)) {
      return billCharges
    } else if (departmentChargeRole) {
      if (departmentTeamUser === null) {
        departmentTeamUser = await User.getUserDepartmentTeam()
      }
      return getDepartRoleBillingCharges(view, billCharges, otherParams, departmentTeamUser)
    } else if (userChargeRole) {
      return matchBillChargesByCreateByRole(view, billCharges, otherParams)
    }
  }
  return null
}

// 匹配账单页签的费用
function matchBillTabCharges(view, charges, oversea, otherParams) {
  const { enableCommission, showSpecialCharge, currentBillingBranchId } = otherParams
  const result = []
  for (const charge of charges) {
    if (RateUtil.useOrderCenterMode() && charge.branchId !== view.$store.getters.currentOfficeId) {
      continue
    }
    if (!charge.billingUuid && charge.oversea === oversea && charge.offsetState === 0 && !charge.shared) {
      if (!enableCommission) {
        result.push(charge)
      } else {
        if (showSpecialCharge && currentBillingBranchId > 0) {
          if (charge.branchId === currentBillingBranchId) {
            result.push(charge)
          }
        } else {
          if (charge.branchId === view.$store.getters.currentOfficeId) {
            result.push(charge)
          }
        }
      }
    }
  }
  return result
}

// 根据创建人角色匹配账单页签的费用
function matchBillChargesByCreateByRole(view, charges, otherParams) {
  const { enableCommission, showSpecialCharge, currentBillingBranchId } = otherParams
  const user = getUserInfo()
  const result = []
  for (const charge of charges) {
    if (charge.createdBy === user.userId) {
      if (!enableCommission) {
        result.push(charge)
      } else {
        if (showSpecialCharge && currentBillingBranchId > 0) {
          if (charge.branchId === currentBillingBranchId) {
            result.push(charge)
          }
        } else {
          if (charge.branchId === view.$store.getters.currentOfficeId) {
            result.push(charge)
          }
        }
      }
    }
  }
  return result
}

// 12已复核,13未复核
export async function checkBillingState(view, billing) {
  const statusRequirement = view.billingGroupCreateBillingStatusRequirement
  if (statusRequirement && ((billing.review && statusRequirement.includes('12')) || (!billing.review && statusRequirement.includes('13')))) {
    return true
  }
  return false
}

// 校验job费用是否是自己创建的
function checkChargeCreatedBy(job) {
  const user = getUserInfo()
  for (const charge of job.charges) {
    if (charge.createdBy !== user.userId) {
      return false
    }
  }
  return true
}

// 同组部门费用过滤
function getDepartRoleBillingCharges(view, charges, otherParams, departmentTeamUser) {
  const { enableCommission, showSpecialCharge, currentBillingBranchId } = otherParams
  const result = []
  if (charges && charges.length > 0) {
    for (const charge of charges) {
      if (checkDepartmentTeam(view, charge, departmentTeamUser)) {
        if (!enableCommission) {
          result.push(charge)
        } else {
          if (showSpecialCharge && currentBillingBranchId > 0) {
            if (charge.branchId === currentBillingBranchId) {
              result.push(charge)
            }
          } else {
            if (charge.branchId === view.$store.getters.currentOfficeId) {
              result.push(charge)
            }
          }
        }
      }
    }
  }
  return result
}

// 同组费用查看
function checkDepartmentTeam(view, charge, departmentTeamUser) {
  if (charge.createdBy === view.$store.getters.userId) {
    return true
  }
  for (const userId of departmentTeamUser) {
    if (userId === charge.createdBy) {
      return true
    }
  }
  return false
}

/**
 *  国外账单打印（正式打印）账单状态校验
 * @param billings
 * @returns {boolean}
 */
export function hasOverseasBillVarifyBillStatus(billings) {
  let hasOverseasBillVerify = true
  if (!billings || billings.length === 0) {
    return hasOverseasBillVerify
  }
  const overseasBillVarifyBillStatus = String(cache.config.get('OverseasBillVarifyBillStatus'))
  if (!StrUtils.isEmpty(overseasBillVarifyBillStatus)) {
    const arrays = overseasBillVarifyBillStatus.split(',')
    const billingStates = []
    const billingReviews = []
    if (arrays && arrays.length > 0) {
      for (const item of arrays) {
        if (item && item.trim().length > 0) {
          const state = Number(item.trim())
          if (state === BillingConstants.BILLING_STATE_REVIEWED.code || state === BillingConstants.BILLING_STATE_NOT_REVIEW.code) {
            billingReviews.push(state === BillingConstants.BILLING_STATE_REVIEWED.code ? BillingConstants.BILLING_REVIEWED.code : BillingConstants.BILLING_NOT_REVIEW.code)
          } else {
            billingStates.push(state)
          }
        }
      }
    }
    console.log('billingStates:', billingStates, 'billingReviews:', billingReviews)
    for (const billing of billings) {
      if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) {
        let hasBillingStates = true
        let hasBillingReviews = true
        if (!billingStates || billingStates.length === 0 || (billingStates && billingStates.length > 0 && !billingStates.includes(billing.state))) {
          hasBillingStates = false
        }
        if (!billingReviews || billingReviews.length === 0 || (billingReviews && billingReviews.length > 0 && !billingReviews.includes(billing.review))) {
          hasBillingReviews = false
        }
        if (!hasBillingStates && !hasBillingReviews) {
          hasOverseasBillVerify = false
          break
        }
      }
    }
  }
  return hasOverseasBillVerify
}

export async function setBillingInvoiceInformation(billing = null, charges = []) {
  if (!billing || !charges || charges.length === 0) {
    return
  }
  const loading = getLoading()
  const keys = [...new Set(charges.map(d => d.uuid))]
  getBillingInvoiceRemarkFun({ keys: keys, branchId: $store.getters.currentOfficeId }).then(res => {
    const data = res.data
    if (data) {
      billing.invoiceRemark = data.invoiceRemark
      billing.remarkAddContent = data.remarkAddContent
      billing.billingBeforehandVOS = data.invoiceGoodsNameRowData
    }
  }).finally(() => {
    loading.close()
  })
}
